import { useSuspenseQuery } from '@apollo/client/react';
import { GET_CONTROLLING_EINSTELLUNGEN_BY_STANDORT_ID } from './graphql/queries';
import {
  AbsatzProduktivitaetEinstellungen,
  AbsatzVorgabe,
  TagebuchEinstellungen,
  UmsatzProduktivitaetEinstellungen,
} from '../entities/tagebuchEinstellungen';
import { Anzeige } from '../entities/tagebuchAnzeige';
import useLocalStorageState from 'use-local-storage-state';
import {
  GetControllingEinstellungenByStandortIdQuery,
  GetControllingEinstellungenByStandortIdQueryVariables,
} from '@/gql/graphql';

export function useTagebuchEinstellungen(standortId: string): {
  tagebuchEinstellungen?: TagebuchEinstellungen;
  error?: string;
  umsatzplanungAnzeige?: Anzeige;
} {
  const [umsatzplanungAnzeige] = useLocalStorageState<Anzeige>(
    'umsatzplanungAnzeige',
    {
      defaultValue: 'UMSATZ_ABSATZ_PRODUKTIVITAET',
    },
  );

  const { data, error } = useSuspenseQuery<
    GetControllingEinstellungenByStandortIdQuery,
    GetControllingEinstellungenByStandortIdQueryVariables
  >(GET_CONTROLLING_EINSTELLUNGEN_BY_STANDORT_ID, {
    variables: { standortId },
    fetchPolicy: 'network-only',
  });

  if (error) {
    return { error: error.message };
  }

  const controllingEinstellungen = data.controlling;

  if (controllingEinstellungen.length > 1) {
    return {
      error:
        'Es sollten nicht für mehrere Standorte die Controllingeinstellungen zurückgegeben werden',
    };
  }

  const tagebuchEinstellungen = data.controlling[0].einstellungen;

  const absatzVorgabe = !tagebuchEinstellungen?.absatzProduktivitaet
    .absatzVorgabe
    ? AbsatzVorgabe.Stueck
    : AbsatzVorgabe[tagebuchEinstellungen.absatzProduktivitaet.absatzVorgabe];

  return {
    umsatzplanungAnzeige,
    tagebuchEinstellungen: new TagebuchEinstellungen({
      absatzProduktivitaet: new AbsatzProduktivitaetEinstellungen({
        absatzVorgabe,
        zielProduktivitaet:
          tagebuchEinstellungen?.absatzProduktivitaet.zielProduktivitaet ?? 0,
      }),
      umsatzProduktivitaet: new UmsatzProduktivitaetEinstellungen({
        zielProduktivitaet:
          tagebuchEinstellungen?.umsatzProduktivitaet.zielProduktivitaet ?? 0,
      }),
    }),
  };
}
